import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './App';
import { installPrintBridge } from './lib/printBridge';
import { installNumberInputGuard } from './lib/numberInputGuard';

// Universal print: with the Print Bridge installed every window.print() goes silently to the chosen printer.
installPrintBridge({ rememberKey: 'restoboxx' });
// Every numeric box in the app: "022" corrects to "22" as it is typed.
installNumberInputGuard();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);
